// src/utils/rememberedTutor.js
// The tutor (org) of whoever last signed in on this device, so the login
// page can show that tutor's logo before anyone has signed in. A display
// hint only: it never affects who can sign in or what they see afterwards.
// Browser storage can be unavailable (private windows, blocked site data),
// so every access is guarded - a failure just means the generic login page.

const KEY = 'hs.lastTutor';

export const rememberTutor = (orgId, role) => {
  try {
    if (orgId) localStorage.setItem(KEY, JSON.stringify({ orgId, role: role || 'student' }));
  } catch (e) { /* storage unavailable - nothing to remember */ }
};

export const getRememberedTutor = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || 'null');
    return value && value.orgId ? value : null;
  } catch (e) {
    return null;
  }
};
